module.exports = __webpack_public_path__ + "static/media/gh4.40549a7f.png";